export const amountToString = (amount: number): string => {
    return Math.round(amount).toLocaleString()
}